"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _RadioGroup = _interopRequireDefault(require("./RadioGroup.js"));

var _type = require("./type.js");

require("prop-types");

require("./SelectionGroup.js");

require("./chunk-48de8464.js");

require("./chunk-e8276423.js");

require("./layout.js");

require("./chunk-b15f6972.js");

require("./chunk-6104512b.js");

require("./chunk-76875e58.js");

require("./chunk-cb015231.js");

require("./chunk-f2932d1d.js");

require("./chunk-eb19ede6.js");

require("./chunk-8219403d.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject4() {
  var data = (0, _chunkB2edacfb.a)(["\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 10px;\n\n  font-weight: 600;\n  color: ", ";\n  cursor: pointer;\n\n  &:first-of-type {\n    margin-top: 6px;\n  }\n\n  &:hover {\n    color: ", ";\n\n    & ", " {\n      box-shadow: inset 0 0 0 ", "\n        ", ";\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _chunkB2edacfb.a)(["\n  position: relative;\n  display: flex;\n  margin-right: 8px;\n  margin-top: 2px;\n  width: 16px;\n  height: 16px;\n  border-radius: 10px;\n  background-color: white;\n  transition: box-shadow 0.2s ease;\n  box-shadow: inset 0 0 0 ", "\n    ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _chunkB2edacfb.a)(["\n  flex-direction: column;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  z-index: -1;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CRadio = function CRadio(_ref) {
  var children = _ref.children,
      label = _ref.label,
      caption = _ref.caption,
      props = (0, _chunkB2edacfb.j)(_ref, ["children", "label", "caption"]);
  return _react.default.createElement(StyledLabel, {
    checked: props.checked
  }, _react.default.createElement(HiddenInput, (0, _chunkB2edacfb.g)({
    type: "radio"
  }, props)), _react.default.createElement(RadioIndicator, {
    checked: props.checked
  }), _react.default.createElement(Content, null, _react.default.createElement(_type.Text, null, label), children, caption && _react.default.createElement(_type.Caption, null, caption)));
};

CRadio.displayName = "CRadio";
CRadio.Group = _RadioGroup.default;

var HiddenInput = _styledComponents.default.input.withConfig({
  displayName: "CRadio__HiddenInput",
  componentId: "qqwaje-0"
})(_templateObject());

var Content = _styledComponents.default.div.withConfig({
  displayName: "CRadio__Content",
  componentId: "qqwaje-1"
})(_templateObject2());

var RadioIndicator = _styledComponents.default.div.withConfig({
  displayName: "CRadio__RadioIndicator",
  componentId: "qqwaje-2"
})(_templateObject3(), function (props) {
  return props.checked ? "6px" : "2px";
}, function (props) {
  return props.theme[props.checked ? "$blue" : "$gray-5"];
});

var StyledLabel = _styledComponents.default.label.withConfig({
  displayName: "CRadio__StyledLabel",
  componentId: "qqwaje-3"
})(_templateObject4(), function (props) {
  return props.theme["$gray-7"];
}, function (props) {
  return props.theme["$blue-dark"];
}, RadioIndicator, function (props) {
  return props.checked ? "6px" : "2px";
}, function (props) {
  return props.theme["$blue-dark"];
});

CRadio.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CRadio"
};
var _default = CRadio;
exports.default = _default;
CRadio.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CRadio"
};